import { useEffect, useRef, useState } from 'react';

const PHOTO_LARGE_LEFT = 'https://storage.readdy-site.link/project_files/c43d99a8-1e00-428b-96a3-32143e86ff11/d0c50b74-0b49-4af7-9638-3bc00a5b2734_WhatsApp-Image-2026-02-26-at-9.59.38-AM.jpeg?v=fd31804b086ebc9b35944377b1598122';
const PHOTO_RIGHT = 'https://storage.readdy-site.link/project_files/c43d99a8-1e00-428b-96a3-32143e86ff11/c14c74ec-f266-448e-a1b4-33a53e2a3a85_WhatsApp-Image-2026-02-26-at-9.59.38-AM-2.jpeg?v=ba211e6d9a155875206021a1576597d3';
const PHOTO_ROW2_LEFT = 'https://storage.readdy-site.link/project_files/c43d99a8-1e00-428b-96a3-32143e86ff11/5b56e0a8-e049-4100-a80c-9d8b0642ea34_WhatsApp-Image-2026-02-26-at-9.59.38-AM-1.jpeg?v=1361451fa257137f8bfbc2f6de744d85';
const PHOTO_ROW2_CENTER = 'https://storage.readdy-site.link/project_files/c43d99a8-1e00-428b-96a3-32143e86ff11/cfa2b887-5c44-4c11-b7b8-a4844cbdde37_WhatsApp-Image-2026-02-26-at-9.59.37-AM-1.jpeg?v=c382aea260e78b83d7202b490cc139ed';
const PHOTO_ROW2_RIGHT = 'https://storage.readdy-site.link/project_files/c43d99a8-1e00-428b-96a3-32143e86ff11/a0075a23-82ff-48fe-8773-40e1a3e80530_WhatsApp-Image-2026-02-26-at-9.59.39-AM.jpeg?v=8dbdb05df6131ddc45a942635e82311f';

const NARRATIVE_CARDS = [
  {
    num: '01',
    bgColor: '#F8F8F8',
    borderRight: '1px solid rgba(20,60,60,0.1)',
    accentColor: '#DC5014',
    iconBg: 'rgba(220,80,20,0.1)',
    numColor: 'rgba(220,80,20,0.06)',
    iconClass: 'ri-team-line',
    label: 'THIS IS YOUR TEAM',
    title: 'A Full Corporate Team\nWorking Under Your Name.',
    isList: true,
    list: [
      'General Contractor',
      'Project Management',
      'Architecture',
      'Interior Design',
      'Cabinets & Kitchen',
    ],
    bodyColor: 'rgba(20,60,60,0.6)',
    titleColor: '#143C3C',
  },
  {
    num: '02',
    bgColor: '#143C3C',
    borderRight: '1px solid rgba(100,180,180,0.1)',
    accentColor: '#64B4B4',
    iconBg: 'rgba(100,180,180,0.12)',
    numColor: 'rgba(100,180,180,0.05)',
    iconClass: 'ri-building-2-line',
    label: 'THIS IS YOUR SHOWROOM',
    title: '4,000 SQF of Luxury\nat Your Disposal.',
    isList: false,
    body: 'Premium finishes, furniture displays and meeting rooms available for every client presentation. Your client walks in and immediately knows they are dealing with the best in the business.',
    bodyColor: 'rgba(240,240,240,0.6)',
    titleColor: '#F0F0F0',
  },
  {
    num: '03',
    bgColor: '#F8F8F8',
    borderRight: 'none',
    accentColor: '#DC5014',
    iconBg: 'rgba(220,80,20,0.1)',
    numColor: 'rgba(220,80,20,0.06)',
    iconClass: 'ri-trophy-line',
    label: 'THIS IS YOUR ADVANTAGE',
    title: '25+ Years of Combined\nMarket Experience.',
    isList: false,
    body: 'Our team brings over 25 years of experience in the U.S. construction market working for your business, your clients and your growth. You deliver the work. We deliver the authority.',
    bodyColor: 'rgba(20,60,60,0.6)',
    titleColor: '#143C3C',
  },
];

const captionStyle: React.CSSProperties = {
  fontFamily: 'Inter, sans-serif',
  fontSize: '10px',
  color: '#999',
  textTransform: 'uppercase',
  letterSpacing: '0.1em',
  marginTop: '8px',
};

export default function ShowroomSection() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.08 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="showroom"
      ref={ref}
      style={{ background: '#FFFFFF' }}
    >
      {/* ── HEADER ── */}
      <div
        className="px-4 md:px-[80px]"
        style={{ paddingTop: '100px', paddingBottom: '0' }}
      >
        <div
          className={`flex flex-col items-center text-center transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          {/* Eyebrow */}
          <div className="flex items-center justify-center" style={{ gap: '14px', marginBottom: '28px' }}>
            <div style={{ width: '32px', height: '1px', background: '#DC5014', flexShrink: 0 }} />
            <span
              style={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 600,
                fontSize: '11px',
                color: '#DC5014',
                letterSpacing: '0.28em',
                textTransform: 'uppercase',
              }}
            >
              YOUR NEW HEADQUARTERS
            </span>
            <div style={{ width: '32px', height: '1px', background: '#DC5014', flexShrink: 0 }} />
          </div>

          {/* Headline */}
          <h2
            style={{
              fontFamily: '"Playfair Display", serif',
              fontSize: 'clamp(36px, 5vw, 64px)',
              fontWeight: 400,
              color: '#0A0A0A',
              lineHeight: 1.0,
              maxWidth: '800px',
              margin: '0 auto 24px',
              textAlign: 'center',
            }}
          >
            Walk In as a Contractor.
            <br />Walk Out as a Corporation.
          </h2>

          {/* Sub */}
          <p
            style={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 300,
              fontSize: '18px',
              color: '#555',
              maxWidth: '700px',
              margin: '0 auto',
              lineHeight: 1.9,
              textAlign: 'center',
            }}
          >
            From the moment your client steps into our 4,000 SQF showroom, they&apos;re not
            meeting a contractor. They&apos;re meeting a company with 25+ years of experience —
            General Contractors, Project Managers, Architects, Designers, Cabinet and Kitchen
            specialists. All under one roof.{' '}
            <strong style={{ fontWeight: 600, color: '#0A0A0A' }}>All representing YOUR brand.</strong>
          </p>
        </div>

        {/* ── MOSAIC GALLERY ── */}
        <div
          className={`transition-all duration-700 delay-200 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          style={{ marginTop: '64px' }}
        >
          {/* Row 1 — 2 photos */}
          <div
            className="hidden md:grid"
            style={{ gridTemplateColumns: '1.6fr 1fr', gap: '6px', height: '520px' }}
          >
            {/* Large left */}
            <div className="flex flex-col">
              <div style={{ height: '520px', overflow: 'hidden' }}>
                <img
                  src={PHOTO_LARGE_LEFT}
                  alt="The Showroom — 4,000 Sqft"
                  className="w-full h-full object-cover object-center transition-transform duration-500 ease-out hover:scale-[1.02]"
                />
              </div>
              <p style={captionStyle}>The Showroom — 4,000 Sqft</p>
            </div>
            {/* Right */}
            <div className="flex flex-col">
              <div style={{ height: '520px', overflow: 'hidden' }}>
                <img
                  src={PHOTO_RIGHT}
                  alt="Living &amp; Kitchen Display"
                  className="w-full h-full object-cover object-center transition-transform duration-500 ease-out hover:scale-[1.02]"
                />
              </div>
              <p style={captionStyle}>Living &amp; Kitchen Display</p>
            </div>
          </div>

          {/* Row 1 — mobile stacked */}
          <div className="flex flex-col md:hidden gap-[6px]">
            <div>
              <div style={{ height: '260px', overflow: 'hidden' }}>
                <img src={PHOTO_LARGE_LEFT} alt="The Showroom — 4,000 Sqft" className="w-full h-full object-cover object-center" />
              </div>
              <p style={captionStyle}>The Showroom — 4,000 Sqft</p>
            </div>
            <div>
              <div style={{ height: '260px', overflow: 'hidden' }}>
                <img src={PHOTO_RIGHT} alt="Living &amp; Kitchen Display" className="w-full h-full object-cover object-center" />
              </div>
              <p style={captionStyle}>Living &amp; Kitchen Display</p>
            </div>
          </div>

          {/* Row 2 — 3 photos desktop */}
          <div
            className="hidden md:grid"
            style={{ gridTemplateColumns: '1fr 1fr 1fr', gap: '6px', marginTop: '6px', height: '320px' }}
          >
            <div className="flex flex-col">
              <div style={{ height: '320px', overflow: 'hidden' }}>
                <img
                  src={PHOTO_ROW2_LEFT}
                  alt="Custom Kitchen Display"
                  className="w-full h-full object-cover object-center transition-transform duration-500 ease-out hover:scale-[1.02]"
                />
              </div>
              <p style={captionStyle}>Custom Kitchen Display</p>
            </div>
            <div className="flex flex-col">
              <div style={{ height: '320px', overflow: 'hidden' }}>
                <img
                  src={PHOTO_ROW2_CENTER}
                  alt="VIP Meeting Room"
                  className="w-full h-full object-cover object-center transition-transform duration-500 ease-out hover:scale-[1.02]"
                />
              </div>
              <p style={captionStyle}>VIP Meeting Room</p>
            </div>
            <div className="flex flex-col">
              <div style={{ height: '320px', overflow: 'hidden' }}>
                <img
                  src={PHOTO_ROW2_RIGHT}
                  alt="Premium Finishes"
                  className="w-full h-full object-cover object-center transition-transform duration-500 ease-out hover:scale-[1.02]"
                />
              </div>
              <p style={captionStyle}>Premium Finishes</p>
            </div>
          </div>

          {/* Row 2 — mobile stacked */}
          <div className="flex flex-col md:hidden gap-[6px] mt-[6px]">
            {[
              { src: PHOTO_ROW2_LEFT, caption: 'Custom Kitchen Display' },
              { src: PHOTO_ROW2_CENTER, caption: 'VIP Meeting Room' },
              { src: PHOTO_ROW2_RIGHT, caption: 'Premium Finishes' },
            ].map((p) => (
              <div key={p.caption}>
                <div style={{ height: '260px', overflow: 'hidden' }}>
                  <img src={p.src} alt={p.caption} className="w-full h-full object-cover object-center" />
                </div>
                <p style={captionStyle}>{p.caption}</p>
              </div>
            ))}
          </div>
        </div>

        {/* ── 3 NARRATIVE CARDS ── */}
        <div
          className={`grid grid-cols-1 md:grid-cols-3 transition-all duration-700 delay-300 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          style={{ gap: '0', marginTop: '80px' }}
        >
          {NARRATIVE_CARDS.map((card, i) => (
            <div
              key={card.num}
              className="relative overflow-hidden"
              style={{
                background: card.bgColor,
                borderRight: card.borderRight,
                padding: '48px 40px',
                borderBottom: i < 2 ? undefined : undefined,
              }}
            >
              {/* Decorative number */}
              <span
                className="absolute select-none pointer-events-none"
                style={{
                  fontFamily: '"Playfair Display", serif',
                  fontSize: '120px',
                  color: card.numColor,
                  bottom: '-10px',
                  right: '16px',
                  lineHeight: 1,
                }}
              >
                {card.num}
              </span>

              {/* Label */}
              <div className="flex items-center" style={{ gap: '10px' }}>
                <div style={{ width: '24px', height: '1px', background: card.accentColor, flexShrink: 0 }} />
                <span
                  style={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 600,
                    fontSize: '10px',
                    color: card.accentColor,
                    letterSpacing: '0.22em',
                    textTransform: 'uppercase',
                  }}
                >
                  {card.label}
                </span>
              </div>

              {/* Icon */}
              <div
                className="flex items-center justify-center"
                style={{
                  width: '44px',
                  height: '44px',
                  borderRadius: '50%',
                  background: card.iconBg,
                  margin: '24px 0 20px',
                }}
              >
                <i className={card.iconClass} style={{ color: card.accentColor, fontSize: '20px' }} />
              </div>

              {/* Title */}
              <h3
                style={{
                  fontFamily: '"Playfair Display", serif',
                  fontSize: '22px',
                  fontWeight: 400,
                  color: card.titleColor,
                  lineHeight: 1.3,
                  marginBottom: '16px',
                  whiteSpace: 'pre-line',
                }}
              >
                {card.title}
              </h3>

              {/* Body or List */}
              {card.isList ? (
                <ul>
                  {card.list!.map((item) => (
                    <li
                      key={item}
                      style={{
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 300,
                        fontSize: '13px',
                        color: card.bodyColor,
                        lineHeight: 2.2,
                      }}
                    >
                      · {item}
                    </li>
                  ))}
                </ul>
              ) : (
                <p
                  style={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 300,
                    fontSize: '14px',
                    color: card.bodyColor,
                    lineHeight: 1.8,
                  }}
                >
                  {card.body}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* ── IMPACT BLOCK ── */}
      <div
        className={`text-center transition-all duration-700 delay-400 px-4 md:px-[80px] ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        style={{
          background: '#143C3C',
          paddingTop: '80px',
          paddingBottom: '80px',
          marginTop: '0',
        }}
      >
        {/* Decorative line */}
        <div style={{ width: '60px', height: '1px', background: '#DC5014', margin: '0 auto 32px' }} />

        {/* Main phrase */}
        <p
          style={{
            fontFamily: '"Playfair Display", serif',
            fontSize: 'clamp(24px, 3.5vw, 40px)',
            fontStyle: 'italic',
            fontWeight: 400,
            color: '#F0F0F0',
            maxWidth: '640px',
            margin: '0 auto',
            lineHeight: 1.3,
          }}
        >
          &ldquo;You don&apos;t need to build a $10M company.
          <br />You just need to walk into one.&rdquo;
        </p>

        {/* Sub */}
        <p
          style={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 300,
            fontSize: '18px',
            color: 'rgba(240,240,240,0.5)',
            marginTop: '16px',
          }}
        >
          That&apos;s exactly what Barkfy gives you — from day one as an Elite Partner.
        </p>

        {/* CTA Button */}
        <button
          type="button"
          onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
          className="cursor-pointer whitespace-nowrap"
          style={{
            background: '#DC5014',
            color: '#F0F0F0',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 700,
            fontSize: '13px',
            padding: '18px 48px',
            borderRadius: '4px',
            border: 'none',
            marginTop: '36px',
            display: 'inline-block',
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
          }}
        >
          SCHEDULE YOUR FIRST MEETING HERE
        </button>

        {/* Note */}
        <p
          style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: '11px',
            color: '#64B4B4',
            fontStyle: 'italic',
            marginTop: '12px',
          }}
        >
          Exclusive access for Barkfy Elite Partners only.
        </p>
      </div>
    </section>
  );
}
